import { CommunitySearchModule } from './../shared/community-search/community-search.module';
import { ProviderSearchModule } from '../shared/provider-search/provider-search.module';
import { Kno2SearchModule } from '../shared/kno2-search/kno2-search.module';
import { LanguageService } from './service/language.service';
import { OrganizationService } from './service/organization.service';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DictionaryService } from './service/dictionary.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { RegistrationService } from './service/registration.service';
import { UserService } from './service/user.service';
import { SideNavComponent } from './side-nav/side-nav.component';
import { LoginComponent } from './login/login.component';
import { RoutingModule } from './routing/routing.module';
import { CaseService } from './service/case.service';
import { JwtInterceptorService } from './service/jwt-interceptor.service';
import { AuthenticationService } from './authentication/authentication.service';
import { NotesService } from './service/notes.service';
import { ProgramService } from './service/program.service';
import { FieldConfigurationService } from './service/field-configuration.service';
import { TaskService } from './service/task.service';
import { HelpComponent } from './help/help.component';
import { HeaderComponent } from './header/header.component';
import { FilterService } from './filter/filter.service';
import { AppConfigService } from './service/app-config.service';
import { ImageService } from './service/image.service';
import { MessengerService } from './service/messenger.service';
import { SettingService } from './service/setting.service';
import { IdleService } from './service/idle.service';
import { WebSocketService } from './service/web-socket.service';
import { SearchHelperService } from './utility/search-helper.service';
import { ProgramCategoryService } from './service/program-category.service';
import { DocumentService } from './service/document.service';
import { HelpDocumentsComponent } from './help/help-documents/help-documents.component';
import { HelpImportProvidersComponent } from './help/help-import-providers/help-import-providers.component';
import { DirectorySearchModule } from '../shared/directory-search/directory-search.module';
import { HelpImportCommunityProgramsComponent } from './help/help-import-community-programs/help-import-community-programs.component';
import { SettingNavComponent } from './setting-nav/setting-nav.component';
import { HelpImportMembersComponent } from './help/help-import-members/help-import-members.component';
import { HelpDocumentService } from './service/help-document.service';
import { FloatingLabelModule } from '@progress/kendo-angular-label';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { TotpComponent } from './totp/totp.component';
import { SelectRoleModule } from '../shared/select-role/select-role.module';
import { SmartLaunchComponent } from './smart/smart-launch/smart-launch.component';
import { SmartRedirectComponent } from './smart/smart-redirect/smart-redirect.component';
import { ChangePasswordModule } from '../shared/change-password/change-password.module';
import { SelectOrganizationModule } from '../shared/select-organization/select-organization.module';

@NgModule({
  declarations: [
    HelpComponent,
    HeaderComponent,
    LoginComponent,
    SideNavComponent,
    HelpDocumentsComponent,
    HelpImportProvidersComponent,
    HelpImportCommunityProgramsComponent,
    SettingNavComponent,
    HelpImportMembersComponent,
    TotpComponent,
    SmartLaunchComponent,
    SmartRedirectComponent
  ],
  exports: [
    RoutingModule,
    HelpComponent,
    HeaderComponent,
    LoginComponent,
    SideNavComponent,
    SettingNavComponent
  ],
  imports: [RoutingModule,
    NgbModule,
    SharedModule,
    ContextMenuModule,
    DirectorySearchModule,
    FloatingLabelModule,
    CommunitySearchModule,
    SelectRoleModule,
    SelectOrganizationModule,
    ProviderSearchModule,
    Kno2SearchModule,
    ChangePasswordModule],
  providers: [
    AuthenticationService,
    JwtInterceptorService,
    FilterService,
    CaseService,
    NotesService,
    ProgramService,
    FieldConfigurationService,
    TaskService,
    UserService,
    DictionaryService,
    AppConfigService,
    OrganizationService,
    ImageService,
    MessengerService,
    SettingService,
    RegistrationService,
    IdleService,
    WebSocketService,
    SearchHelperService,
    LanguageService,
    ProgramCategoryService,
    DocumentService,
    HelpDocumentService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule { }
